import { Tenant, User } from '@innovation-os-ng/core/models';
import { TenantCustomProperties, UserCustomProperties } from '../services/tracking-setup.service';

export interface CustomProperties {
  [key: string]: string | number;
}

export interface CustomPropertiesWithId extends CustomProperties {
  id: string;
}

export interface SkipTrack {
  pageView?: boolean;
  event?: boolean;
  error?: boolean;
}

export interface TrackingIds {
  [trackingId: string]: {
    eventCategory: string;
    eventAction: string;
    eventLabel: string;
    customProperties?: CustomProperties;
  };
}

export interface AnalyticsPageViewEvent {
  tenantName: string;
  tenantId: string;
  spaceId: string;
  url: string;
  userId: string;
  customProperties?: CustomProperties;
}

export interface AnalyticsGenericEvent {
  tenantName: string;
  tenantId: string;
  spaceId: string;
  userId: string;
  eventId: string;
  eventAction: string;
  eventCategory: string;
  eventLabel: string;
  customProperties?: CustomProperties;
}

export interface AnalyticsErrorEvent {
  requestUrl: string;
  responseCode: string;
  requestId: string;
  windowLocation: string;
}

export interface AnalyticsTracker {
  // our strict typing doesn't allow empty interfaces and this interface seems useful
  // this is not strictly required but a small little property in here makes it lint and build!
  type: Tracker;
}

export enum Tracker {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GOOGLE_ANALYTICS = 'ga'
}

export interface TrackerSetup {
  user?: User;
  tenant?: Tenant;
  trackers: Array<{
    tracker: Tracker;
    customProperties?: {
      userCustomProperties?: UserCustomProperties;
      tenantCustomProperties?: TenantCustomProperties;
    };
    key?: string;
  }>;
  trackingIds?: TrackingIds;
}
